import React from "react";
import { AppraiserPasswordSet } from "./AppraiserPasswordSet";

interface ResetPasswordProps {}

export const ResetPassword: React.FC<ResetPasswordProps> = () => {
  return <AppraiserPasswordSet type="reset" />;
};
